import type { GameState, Player, Piece, Corner } from '@sheshdash/shared';

export const cloneGameState = (state: GameState): GameState => {
  if (typeof structuredClone === 'function') {
    return structuredClone(state);
  }
  return JSON.parse(JSON.stringify(state)) as GameState;
};

export const getGameStateKey = (state: GameState): string => JSON.stringify(state);

/** Flatten all pieces from all players, attaching corner info */
export function flattenPieces(players: Player[]): Array<Piece & { corner: Corner }> {
  const result: Array<Piece & { corner: Corner }> = [];
  for (const player of players) {
    for (const piece of player.pieces) {
      result.push({ ...piece, corner: player.corner });
    }
  }
  return result;
}

export function sanitizeMarkdownURL(rawHref?: string): string {
  if (!rawHref) return '#';
  const href = rawHref.trim();
  if (href.startsWith('/')) return href;
  try {
    const parsed = new URL(href, 'https://example.local');
    const protocol = parsed.protocol.toLowerCase();
    if (protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:') return href;
    return '#';
  } catch { return '#'; }
}

type RollDiceAvailabilityParams = {
  isHistoryMode: boolean;
  isMyTurn: boolean;
  canPlacePiece: boolean;
  lastDiceRoll: number;
  canRollAgain: boolean;
};

export function isRollDiceEnabled(params: RollDiceAvailabilityParams): boolean {
  const { isHistoryMode, isMyTurn, canPlacePiece, lastDiceRoll, canRollAgain } = params;
  if (isHistoryMode || !isMyTurn) return false;
  const canInitialRoll = !canPlacePiece && lastDiceRoll === 0;
  return canInitialRoll || canRollAgain;
}
